import { WEEKDAY_SHORT, addDays, parseISODate, shortDate, toISODate, weekStart } from './dates';

// Appointments between a coach and a student, shown in the phone's own time zone (the server keeps UTC).

export const ABSENCE_REASONS = [
  { id: 'busy', label: 'Bận việc' },
  { id: 'sick', label: 'Ốm' },
  { id: 'tired', label: 'Mệt, cần nghỉ' },
  { id: 'other', label: 'Khác' },
];
export const DURATIONS = [45, 60, 90];

export const deviceZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Ho_Chi_Minh';
  } catch {
    return 'Asia/Ho_Chi_Minh';
  }
};

const pad = (n) => String(n).padStart(2, '0');
// "18:00", 24-hour, on this phone.
export const clock = (iso) => {
  const d = new Date(iso);
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
export const localDate = (iso) => toISODate(new Date(iso));
// T2 … CN for a YYYY-MM-DD date.
export const weekdayShort = (isoDate) => WEEKDAY_SHORT[(parseISODate(isoDate).getDay() + 6) % 7];
// "T4 4/11 · 18:00"
export const slotText = (iso) => `${weekdayShort(localDate(iso))} ${shortDate(localDate(iso))} · ${clock(iso)}`;
// A date and an "HH:MM" on this phone, as an ISO time for the API.
export const atTime = (isoDate, hhmm) => {
  const [h, m] = hhmm.split(':').map(Number);
  const d = parseISODate(isoDate);
  d.setHours(h, m, 0, 0);
  return d.toISOString();
};
export const clockMinutes = (hhmm) => {
  const [h, m] = hhmm.split(':').map(Number);
  return h * 60 + m;
};
export const addMinutesToClock = (hhmm, minutes) => {
  const [h, m] = hhmm.split(':').map(Number);
  const total = Math.min(23 * 60 + 59, Math.max(0, h * 60 + m + minutes));
  return `${pad(Math.floor(total / 60))}:${pad(total % 60)}`;
};

// The Monday-to-Sunday week holding `isoDate`, as the API's from/to.
export const weekRange = (isoDate) => {
  const from = weekStart(isoDate);
  return { from, to: addDays(from, 6) };
};
export const weekQuery = (isoDate) => {
  const { from, to } = weekRange(isoDate);
  return `from=${from}&to=${to}&time_zone=${encodeURIComponent(deviceZone())}`;
};
export const weekLabel = (isoDate) => {
  const { from, to } = weekRange(isoDate);
  return `Tuần ${shortDate(from)} – ${shortDate(to)}`;
};

export const absenceLabel = (reason) => ABSENCE_REASONS.find((r) => r.id === reason)?.label;

// What a session is about: the coach taps chips and may add a few words; stored as one line, "Chân · Tay · mang giày".
export const FOCUS = ['Chân', 'Mông', 'Tay', 'Ngực', 'Lưng', 'Vai', 'Bụng', 'Toàn thân', 'Cardio', 'Giãn cơ'];
export const NOTE_MAX = 120;
const SEP = ' · ';
export const splitNote = (note) => {
  const parts = (note || '').split(SEP).map((p) => p.trim()).filter(Boolean);
  return { focus: parts.filter((p) => FOCUS.includes(p)), extra: parts.filter((p) => !FOCUS.includes(p)).join(SEP) };
};
export const joinNote = (focus, extra) => [...FOCUS.filter((f) => focus.includes(f)), (extra || '').trim()].filter(Boolean).join(SEP) || null;
